// Constants

// Hooks
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";
import { useBreakpoint } from "hooks/useBreakpoint";
import {
  FooterSocialType,
  FOOTER_NAVIGATION_ENUMS,
} from "../../../constants/navigation";

import "./styles.sass";

type FooterSocialItemProps = {
  item: FooterSocialType;
};

const FooterSocialItem = (props: FooterSocialItemProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { id, icon, iconDesktop, link } = props.item;

  const t = useTranslate();
  const GTM = useGTM();

  const { isTabletAndLess } = useBreakpoint();

  const handleClick = () => {
    if (id === FOOTER_NAVIGATION_ENUMS.TELEGRAM) {
      GTM.clickTelegram();
    }
    if (id === FOOTER_NAVIGATION_ENUMS.INSTA) {
      GTM.clickInstagram();
    }
    if (id === FOOTER_NAVIGATION_ENUMS.FACEBOOK) {
      GTM.clickFacebook();
    }
  };

  return (
    <a
      href={t(`${link}`)}
      key={id}
      onClick={handleClick}
      target="_blank"
      rel="noreferrer"
      className="FooterSocialItem"
    >
      <div className="FooterSocialItem__icon">
        <img src={isTabletAndLess ? icon : iconDesktop} alt={link} />
      </div>
    </a>
  );
};

export default FooterSocialItem;
